import { useState, useEffect, useCallback, useRef } from 'react';
import { getUserCloudProviders } from '../services/api';

/**
 * Load Vault cloud providers (user API keys) once per page.
 */
export default function useCloudProviders(keycloak, { enabled = true } = {}) {
  const [cloudProviders, setCloudProviders] = useState([]);
  const [loading, setLoading] = useState(false);
  const inFlight = useRef(null);

  const refresh = useCallback(async () => {
    if (!keycloak?.authenticated) return cloudProviders;
    if (inFlight.current) return inFlight.current;

    setLoading(true);
    const promise = getUserCloudProviders(keycloak)
      .then((p) => {
        const list = Array.isArray(p) ? p : [];
        setCloudProviders(list);
        return list;
      })
      .catch(() => {
        setCloudProviders([]);
        return [];
      })
      .finally(() => {
        setLoading(false);
        inFlight.current = null;
      });

    inFlight.current = promise;
    return promise;
  }, [keycloak]);

  useEffect(() => {
    if (!enabled || !keycloak?.authenticated) return;
    refresh();
  }, [enabled, keycloak?.authenticated, refresh]);

  return { cloudProviders, loading, refresh };
}
